import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NavigationService} from '../navigation.service';

@Component({
  selector: 'app-album',
  templateUrl: './album.component.html',
  styleUrls: ['./album.component.scss']
})
export class AlbumComponent implements OnInit {

  front = true;

  constructor(private router: Router, public navigation: NavigationService) {
  }

  ngOnInit(): void {
  }
}
